import axios from 'axios';

const API_BASE_URL = 'https://api.samasong.com/sama-music/';

class UsersAPI {
  static async getUserDetails() {
    try {
      const token = localStorage.getItem('user');
      const response = await axios.get(`${API_BASE_URL}users/get`, {
        headers: {
          Authorization: token ? `Bearer ${token}` : ''
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching user details:', error);
      throw error;
    }
  }

  static async updateUserDetails(userData) {
    try {
      const token = localStorage.getItem('user');
      const response = await axios.put(`${API_BASE_URL}users/update`, userData, {
        headers: {
          Authorization: token ? `Bearer ${token}` : ''
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error updating user details:', error);
      throw error;
    }
  }
}

export default UsersAPI;